import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'bb-privacy-policy',
    templateUrl: './privacy-policy.component.html',
    styleUrls: ['./privacy-policy.component.css']
})
export class PrivacyPolicyComponent implements OnInit {

    constructor() {
    }

    ngOnInit(): void {
    }

}
